import { FieldTypeLink } from '@allesauto/utils/storyblok';
import React, { FC } from 'react';

import { BenefitsTeaserProps } from '.';

type optionalProps = {
  isMultiColor?: boolean;
  numberOfColumns?: number;
  isNumeric?: boolean;
  headline?: string;
  subHeadline?: string;
  textLinkText?: string;
  textLinkHref?: FieldTypeLink;
};

export const BenefitsTeaserAdapter = (
  BenefitsTeaserAdapt: FC<BenefitsTeaserProps & optionalProps>
) => {
  return function benefitsTeaserAdapter(
    props: BenefitsTeaserProps & optionalProps
  ) {
    const flattenArrayProps = {
      ...props,
      benefitTeaser: {
        isMultiColor: props.isMultiColor,
        numberOfColumns: Number(props.numberOfColumns),
        isNumeric: props.isNumeric,
        headline: props.headline,
        subHeadline: props.subHeadline,
        textLinkText: props.textLinkText,
        textLinkHref: props.textLinkHref,
      },
    };
    delete flattenArrayProps.isMultiColor;
    delete flattenArrayProps.numberOfColumns;
    delete flattenArrayProps.isNumeric;
    delete flattenArrayProps.headline;
    delete flattenArrayProps.subHeadline;
    delete flattenArrayProps.textLinkText;
    delete flattenArrayProps.textLinkHref;

    return (
      <BenefitsTeaserAdapt {...(flattenArrayProps as BenefitsTeaserProps)} />
    );
  };
};
